module.exports = __webpack_public_path__ + "static/media/person.d0c49353.svg";